<template>
  <main class="auth-page">
    <div class="auth-theme"><ThemeSwitch /></div>
    <section class="signin-card" aria-labelledby="signin-title">
      <img class="signin-logo" :src="isDark ? '/iosea-logo-white-cropped.png' : '/iosea-logo-cropped.png'" alt="IOSEA">
      <h1 id="signin-title">Sign in</h1>
      <p class="signin-description">Access the IOSEA documentation portal.</p>
      <LoginForm @login="enterHomePage" />
    </section>
  </main>
  <footer class="app-footer auth-footer">
    <div>Copyright &copy; 2026 IOSEA Inc. All rights reserved.</div>
    <div class="footer-version">Documentation version 10-15-2026</div>
  </footer>
</template>

<script>
import { useRouter } from 'vue-router';
import LoginForm from '../components/LoginForm.vue';
import ThemeSwitch from '../components/ThemeSwitch.vue';
import useTheme from '../composables/useTheme';
export default {
  name: 'SignIn',
  components: { LoginForm, ThemeSwitch },
  setup() {
    const router = useRouter();
    const { isDark } = useTheme();
    return { isDark, enterHomePage: () => router.push({ name: 'Home' }) };
  }
};
</script>
